import React from 'react';
import './Footer.css';

function Footer() {
  const legalNodes = [
    {
      href: '/legal/privacy.pdf',
      text: 'Обработка персональных данных',
    },
    {
      href: '/legal/offer.pdf',
      text: 'Договор оферты',
    },
    {
      href: '/legal/payments.pdf',
      text: 'Политика безопасности платежей',
    },
    {
      href: '/legal/payment_and_refund.pdf',
      text: 'Платежи и тарифы',
    },
    {
      href: '/legal/agreement.pdf',
      text: 'Пользовательское соглашение',
    },
    {
      href: '/legal/contacts.pdf',
      text: 'Реквизиты и контакты',
    },
  ];

  const links = [
    {
      href: 'https://t.me/iopp_io',
      text: 'Сообщество в Telegram',
    },
    {
      href: 'https://t.me/ioppio_supportbot',
      text: 'Поддержка',
    },
    {
      href: '/docs',
      text: 'Инструкция по использованию платформы',
    },
    {
      href: '/api/v1/docs',
      text: 'API документация',
    },
    // {
    //   href: 'health',
    //   text: 'Статус платформы',
    // },
  ];
  return (
    <footer className="w-full border-t border-gray-300 bg-gradient-to-t from-[#9cfff22e] to-[#9cfff20a]">
      <div className="flex flex-col justify-between gap-4 px-5 py-7 md:flex-row md:gap-[10px] md:px-10 md:py-10">
        <div className="flex flex-col gap-3">
          <div className="text-lg font-semibold text-gray-800">
            Документация
          </div>
          <div className="flex flex-col gap-1">
            {legalNodes.map((node, index) => {
              return (
                <a
                  key={index}
                  href={node.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-gray-600 transition-all hover:text-blue-500"
                >
                  <span>
                    <span style={{ textDecoration: 'underline' }}>
                      {node.text[0]}
                    </span>
                    {node.text.slice(1)}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <div className="text-lg font-semibold text-gray-800">Ссылки</div>
          <div className="flex flex-col gap-1">
            {links.map((node, index) => (
              <a
                key={index}
                href={node.href}
                target="_blank"
                rel="noreferrer"
                className="text-sm text-gray-600 transition-all hover:text-blue-500"
              >
                <span>
                  <span style={{ textDecoration: 'underline' }}>
                    {node.text[0]}
                  </span>
                  {node.text.slice(1)}
                </span>
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-3 lg:max-w-[40%]">
          <div className="text-lg font-semibold text-gray-800">Контакты</div>
          <div className="flex flex-col gap-1">
            <div className="text-sm text-gray-600">
              Юридический адрес: 445044, Россия, Самарская область, г. Тольятти,
              ул. Автостроителей, д. 36, кв. 107
            </div>
            <div className="text-sm text-gray-600">
              <a className="text-inherit" href="mailto:iopp.io@yandex.ru">
                iopp.io@yandex.ru
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full shrink-0 flex-col items-center gap-2 bg-gray-100 p-2 sm:flex-row sm:gap-5 sm:px-10">
        <div className="text-sm text-gray-600">
          © 2025 <span className="font-bold">iopp</span>
        </div>
        <div className="text-sm text-gray-500">
          ООО {'"Альфа Лайн"'}, ИНН 6321409124, КПП 632101001
        </div>
      </div>
    </footer>
  );
}

export default Footer;
